import {Button} from '@mui/material';
import {MyAppointmentsEnum} from 'presentation/constants';
import {useBookedAppointmentConfirmation} from 'presentation/modules/booking/shared/hooks/useBookedAppointmentConfirmation';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';

const {loadError} = translations['pt-br'].commons;
const {seeMyAppointments} = translations['pt-br'].privateFlow.bookingFlow;
const {detailsTitle} = translations['pt-br'].privateFlow.myAppointments;

export function MyAppointmentDetailsError() {
	const navigate = useNavigate();
	const {id} = useParams();
	const {refresh} = useBookedAppointmentConfirmation(id);

	const goToMyAppointments = () => {
		navigate(MyAppointmentsEnum.MY_APPOINTMENTS);
	};

	return (
		<BookingErrorState
			showHeader={false}
			pageTitle={detailsTitle}
			errorTitle={loadError}
			handleBack={goToMyAppointments}
			handleRefresh={refresh}>
			<Button
				size="large"
				sx={{mx: 'auto', mt: 2, width: 'min-content'}}
				onClick={goToMyAppointments}>
				{seeMyAppointments}
			</Button>
		</BookingErrorState>
	);
}
